import { useAuth0 } from "@auth0/auth0-react";
import { createFileRoute, redirect } from "@tanstack/react-router";

type LoginSearch = {
  redirect: string;
  organization?: string; // The organization ID from Auth0 - if the user is sent to the login page with search params it is an invitation and this field will be populated with the ID.
  invitation?: string;
};

export const Route = createFileRoute("/login")({
  component: Login,
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    return {
      redirect: (search.redirect as string) || "",
      organization: (search.organization as string) || "",
      invitation: (search.invitation as string) || ""
    };
  },
  loaderDeps: ({ search: { invitation, organization } }) => ({
    invitation,
    organization
  }),
  loader: ({ deps: { invitation, organization } }) => {
    if (invitation && organization) {
      redirect({
        to: "/invitation",
        throw: true,
        search: { invitation, organization }
      });
    }
  }
});

function Login() {
  const { redirect: searchRedirect } = Route.useSearch();

  const { loginWithRedirect } = useAuth0();

  loginWithRedirect({
    appState: { returnTo: searchRedirect },
    authorizationParams: {
      redirect_uri: `${window.location.origin}`
    }
  });
}
